var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99996 12.3333H6.66663V13.6666H1.99996C1.25996 13.6666 0.666626 13.0733 0.666626 12.3333V1.66659C0.666626 0.933252 1.25996 0.333252 1.99996 0.333252H9.99996C10.74 0.333252 11.3333 0.933252 11.3333 1.66659V7.35992L10.3333 6.81325L9.99996 6.99992V1.66659H6.66663V6.99992L4.99996 5.49992L3.33329 6.99992V1.66659H1.99996V12.3333ZM14 10.3333L10.3333 8.33325L6.66663 10.3333L10.3333 12.3333L14 10.3333ZM7.99996 11.7266V13.0599L10.3333 14.3333L12.6666 13.0599V11.7266L10.3333 12.9999L7.99996 11.7266Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificates);
export default __webpack_public_path__ + "static/media/certificates.9062c438.svg";
export { ForwardRef as ReactComponent };